<template>
  <div class="shadow-xs rounded">
    <div class="shadow-lg rounded bg-white flex flex-col">
      <div class="inline-flex px-4 h-12 items-center">
        <span class="inline-block truncate text-sm"> Note </span>
      </div>
      <a
        role="button"
        class="relative bg-gray-100"
        style="padding-bottom: 66.666667%"
        @click="edit = true"
      >
        <div class="absolute w-full h-full inline-flex items-center justify-center">
          <div class="flex flex-col items-center space-y-4">
            <svg viewBox="0 0 24 24" fill="currentColor" class="h-12 w-12 text-gray-600">
              <path
                fill="currentColor"
                class="text-yellow-600"
                d="M21 15l-6 5.996L4.002 21A.998.998 0 0 1 3 20.007V3.993C3
                3.445 3.445 3 3.993 3h16.014c.548 0 .993.456.993 1.002V15zM19
                5H5v14h8v-5a1 1 0 0 1 .883-.993L14 13l5-.001V5zm-.829
                9.999L15 15v3.169l3.171-3.17z"
              />
            </svg>
            <p class="text-gray-900">No preview available</p>
          </div>
        </div>
      </a>
      <div v-if="editable" class="px-4 py-3">
        <div v-if="displayConfirmationMessage" class="flex flex-col space-y-2">
          <BaseButton danger small :disabled="pending" @click="deleteNote"> Confirm </BaseButton>
          <BaseButton ghost small :disabled="pending" @click="displayConfirmationMessage = false">
            Cancel
          </BaseButton>
        </div>
        <div v-else class="flex flex-col space-y-2">
          <template>
            <BaseButton primary small @click="edit = true"> Edit </BaseButton>
            <portal to="app-dialog">
              <EditNoteModal v-if="edit" :note-id="id" @closed="edit = false" />
            </portal>
            <BaseButton ghost small @click="confirmDelete"> Delete </BaseButton>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EditNoteModal from './EditNoteModal.vue';

export default {
  name: 'NoteAttachment',
  components: {
    EditNoteModal,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    content: {
      type: String,
      default: null,
    },
    taskId: {
      type: String,
      required: true,
    },
    editable: Boolean,
  },
  data() {
    return {
      displayConfirmationMessage: false,
      pending: false,
      edit: false,
    };
  },
  methods: {
    confirmDelete() {
      this.displayConfirmationMessage = true;
      setTimeout(() => {
        if (this.pending) {
          return;
        }
        this.displayConfirmationMessage = false;
      }, 3000);
    },
    async deleteNote() {
      try {
        this.pending = true;
        await this.$store.dispatch({
          type: 'ui/taskNotes/destroy',
          taskId: this.taskId,
          noteId: this.id,
        });
      } catch (error) {
        //
      } finally {
        this.pending = false;
      }
    },
  },
};
</script>
